import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "../memberAsMember";

export const useMutationMembershipUnlinkSecondaryAsMember = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      opts: Parameters<
        ApiType["customerMembershipApi"]["membershipUnlinkSecondary"]
      >[0],
    ) => api.customerMembershipApi.membershipUnlinkSecondary(opts),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.getCurrentMembershipSubscription(),
      }),
  });
};
